(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["accio-catalog-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('accio-hero-slideshow')) {
    class AccioHeroSlideshow extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        this.index = 0;
        if (this.slides.length < 2) return;

        this.interval = parseInt(this.dataset.interval, 10) || 6000;
        this.autoplay =
          this.dataset.autoplay === 'true' &&
          !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => {
            this.show(parseInt(dot.dataset.index, 10));
            this.restart();
          });
        });

        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.start());

        document.addEventListener('visibilitychange', () => {
          if (document.hidden) {
            this.stop();
          } else {
            this.start();
          }
        });

        this.start();
      }

      disconnectedCallback() {
        this.stop();
      }

      show(next) {
        if (!this.slides.length) return;
        this.index = (next + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, i) => {
          const active = i === this.index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
        this.dots.forEach((dot, i) => {
          const active = i === this.index;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-selected', active ? 'true' : 'false');
        });
      }

      start() {
        this.stop();
        if (!this.autoplay) return;
        this.timer = window.setInterval(() => this.show(this.index + 1), this.interval);
      }

      stop() {
        if (this.timer) {
          window.clearInterval(this.timer);
          this.timer = null;
        }
      }

      restart() {
        this.stop();
        this.start();
      }
    }
    customElements.define('accio-hero-slideshow', AccioHeroSlideshow);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
